import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { initMetaPixel } from './utils/metaPixel';
initMetaPixel('931401796468747');
render(<App data-id="element-209" />, document.getElementById('root'));